<template>
	<Modal :width="500" :title="$t('seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.single.title')"
		   :close-on-click-outside="false"
		   @close="closeNoticeModal">
		<template v-slot:body>
			<div class="modal-content">
				<div class="text_left">
					<span v-html="$t('seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.single.confirmation')"></span>
				</div>
				<table class="w_100 margin_top" style="border-collapse: collapse; border-spacing: 0">
					<tr>
						<td class="text_left"><span class="font_bold font_base">{{$t("common.invoiceAmount")}}:</span></td>
						<td class="text_right"><span>{{ invoiceAmountFormatted }}</span></td>
					</tr>
					<tr v-if="showRetention">
						<td class="text_left"><span class="font_bold">{{ $t("common.retention") }}:</span></td>
						<td class="text_right"><span>{{ retentionRateFormatted }}</span></td>
					</tr>
					<tr>
						<td class="text_left"><span class="font_bold">{{$t("common.discount")}}:</span></td>
						<td class="text_right"><span>{{ discountFormatted }}</span></td>
					</tr>
					<tr v-if="confirmationData.priceCheck.calculationType === enumDef.sellPriceCalculationType.CostOfCapital">
						<td class="text_left"><span class="font_bold">{{$t("common.costOfCapitalPa")}}:</span></td>
						<td class="text_right"><span>{{ costOfCapitalFormatted }}</span></td>
					</tr>
					<tr>
						<td colspan="2">
							<hr>
						</td>
					</tr>
					<template v-if="showRetention">
						<tr class="valid_color">
							<td class="text_left"><span class="font_bold">{{$t("seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.sellingPrice.withRetention")}}:</span></td>
							<td class="text_right font_bold"><span>{{ sellPriceWithRetentionFormatted }}</span></td>
						</tr>
						<tr class="valid_color">
							<td class="text_left"><span class="font_bold">{{$t("seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.sellingPrice.withoutRetention")}}:</span></td>
							<td class="text_right font_bold"><span>{{ sellPriceWithoutRetentionFormatted }}</span></td>
						</tr>
					</template>
					<template v-else>
						<tr class="valid_color">
							<td class="text_left"><span class="font_bold">{{$t("seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.sellingPrice")}}:</span></td>
							<td class="text_right font_bold"><span>{{ sellPriceWithoutRetentionFormatted }}</span></td>
						</tr>
					</template>
				</table>
				<div class="text_left margin_top">
					<span v-html="$t('seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.single.text')"></span>
				</div>
			</div>

			<div class="margin_r margin_top flex_end w_100">
				<md-button class="md-blank margin_r" @click="closeNoticeModal">{{$t("common.button.cancel")}}</md-button>
				<md-button @click="confirm" class="md-primary">{{ $t("common.continue") }}</md-button>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";
import {formatAsMoneyAmount, formatAsPercentage} from "@/common/format";
import {enumDef} from "@/common/enumDefs";

export default {
	components: {
		Modal
	},
	props: {
		confirmationData: Object,
	},
	computed: {
		enumDef() {
			return enumDef;
		},
		invoiceAmountFormatted() {
			return formatAsMoneyAmount(this.confirmationData.amount, { currency: this.confirmationData.currency });
		},
		discountFormatted() {
			return formatAsPercentage(this.confirmationData.priceCheck.discountRate);
		},
		costOfCapitalFormatted() {
			return formatAsPercentage(this.confirmationData.priceCheck.costOfCapitalRate);
		},
		sellPriceWithoutRetentionFormatted() {
			return formatAsMoneyAmount(this.confirmationData.priceCheck.sellPriceWithoutRetention, { currency: this.confirmationData.currency });
		},
		sellPriceWithRetentionFormatted() {
			return formatAsMoneyAmount(this.confirmationData.priceCheck.sellPriceWithRetention, { currency: this.confirmationData.currency });
		},
    	retentionRateFormatted() {
      		return formatAsPercentage(this.confirmationData.retentionCheck.retentionRate);
    	},
		showCostOfCapital() {
			return this.confirmationData.priceCheck.calculationType === enumDef.sellPriceCalculationType.CostOfCapital
		},
		showRetention() {
			return this.confirmationData.retentionAccepted && this.confirmationData.retentionCheck.isRetentionAllowed;
		}
	},
	methods: {
		closeNoticeModal() {
			this.$emit("close");
		},
		confirm() {
			this.$emit("confirm", this.confirmationData);
		},
	}
};
</script>